import { INews, IPartner } from 'api/types/_news';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_INFO, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import CopyWrapper from 'components/Common/CopyWrapper';
import DatePickerCustom from 'components/Common/DatePickerCustom';
import DropdownSelectMultiOption from 'components/Common/DropdownSelectMultiOption';
import DropdownStatus from 'components/Common/DropdownStatus';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TableContainer from 'components/Common/TableContainer';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import { COLORS_STATUS_NEWS, GOVERNMENT_SOURCE_NEWS_TYPE, PUBLISH_NEWS_TYPE, STATUS_NEWS_OPTIONS } from 'helpers/constans';
import { ROLES_FOR_APP, isHavePermissionRole } from 'helpers/role';
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from 'react-countup';
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { deleteNewsMulti, getAllImageCategory, getAllPartners, getAllPlaceTravel, getGovernmentNewsByNormal, putNews } from 'store/thunks';
import { NumberParam, StringParam, useQueryParams, withDefault, } from "use-query-params";
import BoxFooterNews from '../../Components/BoxFooterNews';
import BoxGeneratedNews from '../../Components/BoxGeneratedNews';
import BoxImageSearch from '../../Components/BoxImageSearch';
import BoxSourceNews from '../../Components/BoxSourceNews';
import ButtonLanguage from '../../Components/ButtonLanguage';
import HighlightText from '../../Components/HighlightText';
import NestingFilter from '../../Components/NestingFilter';
import { formatClearHighlightTextWithDateAndKeyword } from 'pages/News/functions';
import ModalConfigGenerate from './ModalConfigGenerate';

interface Option {
  label: string;
  value: string;
}

export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = 'approve_date';

const LogoBasedNewsList = () => {
  let document_w: any = window.document;
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const modalRef = useRef<any>(null);
  const modalBodyInnerRef = useRef<any>(null);

  const modalSourceInnerRefs = useRef<any>([]);

  const isFirstLoadingPageRef = useRef<any>(true);

  const STATUS_NEWS_OPTIONS_LANG = STATUS_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const START_DATE = `${moment().format("Y-MM-DD")}`;
  const END_DATE = `${moment().format("Y-MM-DD")}`;

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 100),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    order_by: withDefault(StringParam, 'DESC'),
    start_date: withDefault(StringParam, START_DATE),
    end_date: withDefault(StringParam, END_DATE),
    approve_date_start: withDefault(StringParam, ''),
    approve_date_end: withDefault(StringParam, ''),
    minister_code: withDefault(StringParam, ''),
    keyword: withDefault(StringParam, ''),
    title: withDefault(StringParam, ''),
    is_used: withDefault(StringParam, STATUS_NEWS_OPTIONS_LANG[0]?.value),
    provinces: withDefault(StringParam, ''),
    cities: withDefault(StringParam, ''),
    region_name: withDefault(StringParam, ''),
    type: withDefault(StringParam, `${GOVERNMENT_SOURCE_NEWS_TYPE.LOGO_BASED_NEWS}`),
  });

  const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");
  const [titleSearch, setTitleSearch] = useState<string>(query?.title || "");
  const [ministerCodeSearch, setMinisterCodeSearch] = useState<string>(query?.minister_code || "");

  const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_NEWS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.is_used)) || null);

  const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);
  const [startDate, endDate] = dateSearch;

  const [dateApproveSearch, setDateApproveSearch] = useState<any[]>([query?.approve_date_start ? moment(query?.approve_date_start, 'Y-MM-DD').toDate() : null, query?.approve_date_end ? moment(query?.approve_date_end || '', 'Y-MM-DD').toDate() : null]);
  const [startApproveDate, endApproveDate] = dateApproveSearch;


  const [listProvince, setListProvince] = useState<any[]>([]);
  const [listCity, setListCity] = useState<any[]>([]);

  const [provinceSpecialCitySearch, setProvinceSpecialCitySearch] = useState<any>(null);
  const [cityCountyDistrictSearch, setCityCountyDistrictSearch] = useState<any>(null);

  const [newsDetail, setNewsDetail] = useState<INews | null>(null);

  const [listNews, setListNews] = useState<{ list: INews[], total: number }>({ list: [], total: 0 });
  const [isListNewsLoading, setIsListNewsLoading] = useState<boolean>(false);

  const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [initialValuesDefault, setInitialValuesDefault] = useState<INews | null>(null);

  const [isOpenModalConfigPrompt, setIsOpenModalConfigPrompt] = useState<boolean>(false);

  const [imageCategories, setImageCategories] = useState<any>([]);
  const [imageInsert, setImageInsert] = useState<any>(null);

  const [partners, setPartners] = useState<IPartner[]>([]);

  const onSetImageInsert = (item: any) => {
    setImageInsert((_prev: any) => item);
  }

  const handleQueryData = async () => {
    setIsListNewsLoading((prev) => true);
    if (isFirstLoadingPageRef?.current === true && query?.page !== 1) {
      setQuery({
        ...query,
        type_page_no_param: '',
        page: 1
      });
      return;
    }
    isFirstLoadingPageRef.current = false;

    const res: any = await getGovernmentNewsByNormal(query);
    setListNews((prev: any) => ({
      list: res?.data?.list || [],
      total: res?.data?.pagination?.total || 0,
    }));
    setIsListNewsLoading((prev) => false);

    if (!!newsDetail && query?.type_page_no_param) {
      if (query?.type_page_no_param === 'prev') {
        setNewsDetail((_prev) => res?.data?.list[res?.data?.list?.length - 1]);
        return;
      }
      if (query?.type_page_no_param === 'next') {
        setNewsDetail((_prev) => res?.data?.list[0]);
        return;
      }
    }
  };

  const handleLoadMore = () => {
    setQuery({
      ...query,
      page: query?.page + 1,
      type_page_no_param: 'next'
    });
  }

  const handleLoadPrev = () => {
    setQuery({
      ...query,
      page: query?.page - 1,
      type_page_no_param: 'prev'
    });
  }


  useEffect(() => {
    handleQueryData();
  }, [JSON.stringify(query)]);

  const searchData = () => {
    const queryNew = {
      ...query,
      start_date: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
      end_date: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
      approve_date_start: startApproveDate ? moment(new Date(startApproveDate)).format("Y-MM-DD") : '',
      approve_date_end: endApproveDate ? moment(new Date(endApproveDate)).format("Y-MM-DD") : '',
      minister_code: ministerCodeSearch || '',
      keyword: keywordSearch || '',
      title: titleSearch || '',
      is_used: statusSearch?.value,
      provinces: provinceSpecialCitySearch?.length ? provinceSpecialCitySearch?.map((item: any) => item.value).join(',') : '',
      cities: cityCountyDistrictSearch?.length ? cityCountyDistrictSearch?.map((item: any) => item.value).join(',') : '',
      page: 1,
      time_request: + new Date()
    };
    if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
      setListNews((prev: any) => ({
        list: [],
        total: 0,
      }));
    }
    setQuery(queryNew);
  };

  const resetData = () => {
    const queryNew = {
      title: '',
      keyword: '',
      is_used: STATUS_NEWS_OPTIONS_LANG[0]?.value,
      type: `${GOVERNMENT_SOURCE_NEWS_TYPE.LOGO_BASED_NEWS}`,
      start_date: `${moment().format("Y-MM-DD")}`,
      end_date: `${moment().format("Y-MM-DD")}`,
      approve_date_start: '',
      approve_date_end: '',
      minister_code: '',
      provinces: '',
      cities: '',
      sort_by: TYPE_SELECT_DEFAULT,
      order_by: 'DESC',
      page: 1,
      time_request: + new Date(),
    };
    if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
      setListNews((prev: any) => ({
        list: [],
        total: 0,
      }));
    }
    setQuery(queryNew, "push");
    setTitleSearch((_prev) => "");
    setKeywordSearch((_prev) => "");
    setStatusSearch(STATUS_NEWS_OPTIONS_LANG[0]);
    setDateSearch([moment(queryNew?.start_date || "", 'Y-MM-DD').toDate(), moment(queryNew?.end_date || "", 'Y-MM-DD').toDate()]);
    setDateApproveSearch([queryNew?.approve_date_start ? moment(queryNew?.approve_date_start, 'Y-MM-DD').toDate() : null, queryNew?.approve_date_end ? moment(queryNew?.approve_date_end || '', 'Y-MM-DD').toDate() : null]);
    setMinisterCodeSearch(queryNew?.minister_code);
    setProvinceSpecialCitySearch(null);
    setCityCountyDistrictSearch(null);
  };

  const handleSetNewsDetail = (detail: INews | null) => {
    setNewsDetail((_prev) => detail);
    if (!!detail && (window?.innerWidth <= 900) && (!document_w.fullscreenElement && !document_w.mozFullScreenElement && !document_w.webkitFullscreenElement)) {
      setTimeout(async () => {
        try {
          if (modalRef.current && modalRef.current.requestFullscreen) {
            await modalRef?.current?.requestFullscreen();
          } else if (modalRef.current && modalRef.current.webkitRequestFullscreen) {
            await modalRef?.current?.webkitRequestFullscreen(); // Safari
          } else if (modalRef.current && modalRef.current.msRequestFullscreen) {
            await modalRef?.current?.msRequestFullscreen(); // IE
          }
        } catch (error) {
          //console.error("Failed to enter fullscreen:", error);
        }
      }, 280);
    }

  }

  const onCloseClick = () => {
    setCurrentLang((_prev) => 'ko');
    handleSetNewsDetail(null);
    onSetImageInsert(null);
    setTypeShowInfoRight((_prev) => 'SOURCE');
  }

  const [typeShowInfoRight, setTypeShowInfoRight] = useState<'IMAGE' | 'SOURCE'>('SOURCE');
  const onShowInfoRightClick = () => {
    setTypeShowInfoRight((_prev) => (_prev === 'IMAGE' ? 'SOURCE' : 'IMAGE'));
  }

  const refContentNews = useRef<any>(null);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const resetCursorToStart = () => {
    const editor = refContentNews?.current;
    if (editor) {
      // editor.selection.collapse(true); 

      const body = editor.getBody();
      const brNode = body.querySelector('br'); // Tìm thẻ <br> đầu tiên
      let targetNode = null;

      if (brNode) {
        targetNode = brNode; // Ưu tiên thẻ <br>
      } else {
        // Nếu không tìm thấy <br>, tìm &nbsp; trong các nút văn bản
        const textNodes = Array.from(body.childNodes).filter((node: any) => node.nodeType === Node.TEXT_NODE && node.nodeValue?.includes('\u00A0'));
        if (textNodes.length > 0) {
          targetNode = textNodes[0];
        }
      }

      if (targetNode) {
        // Đặt con trỏ ngay sau thẻ <br> hoặc &nbsp;
        const parentNode = targetNode.parentNode;
        const offset = Array.from(parentNode.childNodes).indexOf(targetNode) + 1;
        editor.selection.setCursorLocation(parentNode, offset);
      }

      // Cập nhật trạng thái bookmark tại vị trí mới
      const newBookmark = editor.selection.getBookmark();
      // editor?.selection.setCursorLocation(null, 0);
    };
  };

  const onSaveClick = async (is_show_noti_when_success: boolean = true) => {
    try {
      if (!newsDetail?.id) {
        return;
      }
      setIsSaving((_prev) => true);
      const response: any = await putNews(newsDetail?.id, {
        title: refContentNews?.current?.getTitle() || '',
        body: formatClearHighlightTextWithDateAndKeyword(refContentNews?.current?.getContent() || '')
      });
      if (response?.code === 200) {
        setListNews((prev: any) => ({
          list: (prev?.list || []).map((item: any) => {
            if (String(item?.id) === String(newsDetail?.id)) {
              return ({ ...item, ...response?.data })
            }
            return item;
          }),
          total: Number(prev?.total || 0),
        }));
        setNewsDetail((_prev: any) => ({ ..._prev, ...response?.data }));
        setIsSaving((_prev) => false);
        if (is_show_noti_when_success) {
          toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
        }
      } else {
        setIsSaving((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsSaving((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const scrollModalBodyToTop = () => {
    if (modalBodyInnerRef.current) {
      modalBodyInnerRef.current.scrollTo({ top: 0 });
    }
    if (modalSourceInnerRefs.current) {
      modalSourceInnerRefs.current.forEach((ref: any) => {
        if (ref) {
          ref.scrollTo({ top: 0 });
        }
      });
    }
  };

  const handlePreviousNews = (index_news_current: number = 0) => {
    if (listNews?.list?.length) {
      const indexNewsPrevious = Number(index_news_current) - 1;
      const newsPrevious = listNews?.list[indexNewsPrevious];
      if (!!newsPrevious) {
        handleSetNewsDetail({
          ...(newsPrevious),
          index: indexNewsPrevious,
          disabled_prev: false,
          disabled_next: false
        });
        scrollModalBodyToTop();
        setCurrentLang((_prev) => 'ko');
        setImageInsert(null);
      }
      if (!newsPrevious) {
        if (Number(query?.page) > 1) {
          handleLoadPrev();
        } else {
          toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
        }
      }
    }
  };

  const handleNextNews = (index_news_current: number = 0) => {
    if (listNews?.list?.length) {
      const indexNewsNext = Number(index_news_current) + 1;
      const newsNext = listNews?.list[indexNewsNext];
      if (!!newsNext) {
        handleSetNewsDetail({
          ...(newsNext),
          index: indexNewsNext,
          disabled_prev: false,
          disabled_next: false,
        });
        scrollModalBodyToTop();
        setCurrentLang((_prev) => 'ko');
        setImageInsert(null);
      }
      if (!newsNext) {
        if (Number(query?.page) < Math.ceil(Number(listNews?.total) / Number(query?.limit || 300))) {
          handleLoadMore();
        } else {
          toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
        }
      }
    }
  };

  const handleDownloaded = (info: any) => {
    if (!!info?.id) {
      setListNews((prev: any) => ({
        list: (prev?.list || []).map((item: any) => {
          if (String(item?.id) === String(info?.id)) {
            return ({ ...item, ...info })
          }
          return item;
        }),
        total: Number(prev?.total || 0),
      }));
      setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
    }
  };

  const handlePublished = (info: any) => {
    if (!!info?.id) {
      setListNews((prev: any) => ({
        list: (prev?.list || []).map((item: any) => {
          if (String(item?.id) === String(info?.id)) {
            return ({ ...item, ...info })
          }
          return item;
        }),
        total: Number(prev?.total || 0),
      }));
      setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
    }
  };

  const handleUnPublished = (info: any) => {
    if (!!info?.id) {
      setListNews((prev: any) => ({
        list: (prev?.list || []).map((item: any) => {
          if (String(item?.id) === String(info?.id)) {
            return ({ ...item, ...info })
          }
          return item;
        }),
        total: Number(prev?.total || 0),
      }));
      setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
    }
  };


  const [currentLang, setCurrentLang] = useState<string>('ko');
  const handleChangeLang = (_lang: string) => {
    const lang = newsDetail?.translates?.find((tr) => tr?.language_code === _lang);
    setNewsDetail((_prev) => (
      {
        ..._prev,
        title: lang?.title,
        body: lang?.body,
      } as INews
    ));
    setCurrentLang((_prev) => _lang);
  };

  // Begin::Delete
  const handleConfirmDelete = (item: INews) => {
    setInitialValuesDefault((_prev) => item);
    setIsConfirm((_prev) => true);
  };

  const handleActionDelete = async () => {
    if (!(initialValuesDefault?.id)) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await deleteNewsMulti({
        ids: [initialValuesDefault?.id]
      });
      if (response?.code === 200) {
        setListNews((prev: any) => ({
          list: (prev?.list || []).filter((item: any) => String(item?.id) !== String(initialValuesDefault?.id)),
          total: Number(prev?.total || 0) - 1,
        }));
        setIsConfirmLoading((_prev) => false);
        setIsConfirm((_prev) => false);
        setInitialValuesDefault((_prev) => null);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmClick = () => {
    setInitialValuesDefault((_prev) => null);
    setIsConfirm((_prev) => false);
  }
  // End::Delete

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t('ID'),
        accessor: "id",
        filterable: true,
        sortable: false,
        thWidth: 100,
        thClass: "align-middle text-center",
        Cell: (cell: any) => (
          <>
            <div className="text-center" style={{ minWidth: '80px' }}>
              <CopyWrapper contentCopy={cell?.value}>
                {cell?.value}
              </CopyWrapper>
            </div>
          </>
        ),
      },
      {
        Header: t('Status'),
        accessor: "is_used",
        filterable: false,
        sortable: false,
        thClass: "align-middle text-center",
        thWidth: i18n?.language === 'en' ? 90 : 80,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div style={{ minWidth: '60px' }} className="text-center fs-16">
              <span className={`rounded-pill badge bg-${COLORS_STATUS_NEWS[`${cell?.value || 0}`] || 'success'}`}>
                {STATUS_NEWS_OPTIONS_LANG?.find((s) => String(s?.value) === String(cell?.value))?.label || ''}
              </span>
            </div>
          );
        }
      },
      {
        Header: t('Article Title'),
        accessor: "title",
        filterable: true,
        sortable: false,
        thClass: 'align-middle',
        thWidth: !listNews?.list?.length ? 100 : (window.innerWidth < 1650 ? 270 : 600),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '250px', maxWidth: '600px' }} className="fs-15 cursor-pointer hover-underline" onClick={(e) => { e.preventDefault(); handleSetNewsDetail({ ...item, index: cell?.row?.index }) }}>
              <HighlightText text={item?.title || ''} keyword={item?.keyword || ''} opacity_bg={0.7} />
            </div>
          </>)
        },
      },
      // {
      //   Header: t('Media'),
      //   accessor: "news_publish_log",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: 130,
      //   thClass: 'align-middle text-end',
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     const _news_publish_log = item?.news_publish_log;
      //     const _partner = partners?.find((_p) => String(_p?.id) === String(_news_publish_log?.partner_id));
      //     return (<>
      //       <div style={{ minWidth: '110px' }} className="fs-15 text-end">
      //         {_partner?.name || '-'}
      //       </div>
      //     </>)
      //   },
      // },
      {
        Header: t('Minister Code'),
        accessor: "minister_code",
        filterable: true,
        sortable: true,
        thWidth: 170,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-3" style={{ minWidth: '170px' }}>{cell?.value || '-'}</div>
          </>)
        },
      },
      {
        Header: t('Approve Date'),
        accessor: "approve_date",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (<>
            <div className="text-end pe-3" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || '-'}</span> <br /> <span className="text-secondary">{arrDate?.[1] || '-'}</span> </span>
            </div>
          </>)
        },
      },
      {
        Header: t('Created At'),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Updated At'),
        accessor: "updated_at",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || '-'}</span> <br /> <span className="text-secondary">{arrDate?.[1] || '-'}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Actions'),
        accessor: "__",
        thClass: 'align-middle text-center',
        thWidth: 120,
        sortable: false,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '100px' }}>
              {isHavePermissionRole(ROLES_FOR_APP.AI_NEWS, userPermissions) &&
                <TooltipCustom
                  title={t('Button Update News')}
                  id={`detail-cp-${item?.id}`}
                >
                  <li className=" list-inline-item me-0" id={`detail-us-${item?.id}`}>
                    <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
                      onClick={(e) => { e.preventDefault(); handleSetNewsDetail({ ...item, index: cell?.row?.index }) }}
                    >
                      <i className="ri-pencil-fill align-bottom"></i>
                    </Link>
                  </li>
                </TooltipCustom>
              }
              {isHavePermissionRole(ROLES_FOR_APP.AI_NEWS, userPermissions) && (
                <TooltipCustom
                  title={t('Button Delete News')}
                  id={`detail-cp-${item?.id}`}
                >
                  <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                    <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                      onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
                    >
                      <i className="ri-delete-bin-3-fill align-bottom"></i>
                    </Link>
                  </li>
                </TooltipCustom>
              )}
            </ul>
          );
        },
      },
    ],
    [i18n?.language, listNews?.list?.length, query, partners, userPermissions]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setListNews((prev: any) => ({
      list: [],
      total: 0,
    }));
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy, page: 1 });
    });
  }, []);

  const handleCallAllOption = async () => {
    try {
      const [res1, res2, res3]: any = await Promise.all([getAllImageCategory({}), getAllPartners({}), getAllPlaceTravel()]);;
      setImageCategories((_prev: any) => res1?.data);
      setPartners((_prev: any) => res2?.data);
      const _tree = res3?.data?.tree;
      const _listProvince = _tree?.map((_p: any) => ({ label: _p?.name, province_id: `${_p?.id}`, value: `${_p?.name}` }));
      const _listCity = _tree?.flatMap((_p: any) => _p?.cities?.map((_c: any) => ({ label: _c?.name, province_id: `${_p?.id}`, city_id: `${_c?.id}`, value: `${_c?.name}` })));
      setListProvince((_prev) => _listProvince || []);
      setListCity((_prev) => _listCity || []);

      const _paramProvince = query?.provinces ? query?.provinces?.split(',')?.map((item: any) => String(item).trim()) : null;
      const _paramCity = query?.cities ? query?.cities?.split(',')?.map((item: any) => String(item).trim()) : null;

      const _searchProvince = _listProvince?.filter((item: any) => _paramProvince?.includes(String(item.value)));
      const _searchCity = _listCity?.filter((item: any) => _paramCity?.includes(String(item.value)));

      setProvinceSpecialCitySearch(_searchProvince);
      setCityCountyDistrictSearch(_searchCity);

    } catch (error: any) {
      return error;
    }
  };

  const listCityFilter = useMemo(() => {
    const _provinceIds = (provinceSpecialCitySearch || [])?.map((item: any) => String(item.province_id));
    return listCity?.filter((_c: any) => (_provinceIds?.includes(String(_c?.province_id)) || !_provinceIds?.length));
  }, [listCity, provinceSpecialCitySearch]);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  }

  const handleChangePickerApprove = (values: any[] = []) => {
    setDateApproveSearch((_prev: any) => values);
  }

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Logo Based News')} | ${t('PRESS Ai')}`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);


  const refRight = useRef<any>(null);
  const [position, setPosition] = useState<any>({ left1: 20, left2: 30, top1: 20, top2: 20 });

  useEffect(() => {
    const getPosition = () => {
      if (modalBodyInnerRef.current && refRight.current) {
        const leftRect = modalBodyInnerRef.current.getBoundingClientRect();
        const rightRect = refRight.current.getBoundingClientRect();
        setPosition((_prev: any) => ({ left1: leftRect.left, left2: rightRect.left, top1: leftRect.top, top2: rightRect.top }));
      }
    };

    // Timeout to ensure UI has rendered
    const timeoutId = setTimeout(() => {
      // Get position on mount
      getPosition();
    }, 0);

    // Optionally, track changes on window resize
    window.addEventListener("resize", getPosition);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", getPosition);
    };
  }, [JSON.stringify(newsDetail)]);




  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Logo Based News')} pageTitle={t('Government News')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.AI_NEWS, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <div className="col-5">
                        <div>
                          <h5 className="card-title mb-0">
                            <span className="me-2">{t('Total')}:</span>
                            {(isListNewsLoading && query?.page === 1) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                              start={0}
                              end={listNews?.total || 0}
                              duration={1}
                              className="text-primary"
                            />)}
                          </h5>
                        </div>
                      </div>
                      <div className="col-7 text-end">
                        {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_GOVERNMENT_NEWS, userPermissions) && (<button
                          type="button"
                          className="btn btn-primary add-btn rounded-pill ms-2"
                          onClick={() => setIsOpenModalConfigPrompt((_prev: any) => true)}
                        >
                          <i className="ri-settings-line align-bottom"></i>
                          <span className="ms-1">{t('Config Generate')}</span>
                        </button>)}
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-0 pb-md-4 px-0 px-lg-3 pt-0 pt-lg-3">
                    <NestingFilter>
                      <Row className="g-4 align-items-end mt-0">

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Status')} isShow={true}>
                            <DropdownStatus
                              name="status"
                              dataList={STATUS_NEWS_OPTIONS_LANG || []}
                              placeholder={`${t("Status")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={statusSearch || null}
                              onChangeSelect={(e: any) => setStatusSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={COLORS_STATUS_NEWS}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-3 order-3 order-xxl-0'>
                          <LabelWrapper label={t('Province / Special City')} isShow={true}>
                            <DropdownSelectMultiOption
                              name={`province_special_city`}
                              dataList={listProvince}
                              placeholder={`${t("Province / Special City")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              isHaveMoreInfo={true}
                              initialValue={provinceSpecialCitySearch || null}
                              onChangeSelect={(e: any) => {
                                setProvinceSpecialCitySearch(e)
                              }}
                              isHasOptionAll={true}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-3 order-3 order-xxl-0'>
                          <LabelWrapper label={t('City / County / District')} isShow={true}>
                            <DropdownSelectMultiOption
                              name={`city_county_district`}
                              dataList={listCityFilter}
                              placeholder={`${t("City / County / District")}...`}
                              className="search-filter-category-type dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={cityCountyDistrictSearch || null}
                              isHaveMoreInfo={true}
                              onChangeSelect={(e: any) => {
                                setCityCountyDistrictSearch(e)
                              }}
                              isHasOptionAll={true}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={3} className='date-picker-wrapper-custom mt-3 mt-xxl-2 order-2 order-xxl-0'>
                          <LabelWrapper label={t('Approve Date')} isShow={true}>
                            <DatePickerCustom
                              placeholder={`${t('Start Date')} - ${t('End Date')}`}
                              startDate={startApproveDate || null}
                              endDate={endApproveDate || null}
                              onChangePicker={handleChangePickerApprove}
                              showOptions={[
                                'today', 'yesterday', 'two_day_ago',
                                'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                'this_week', 'last_week',
                                'this_month', 'last_month',
                              ]}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={3} className='date-picker-wrapper-custom mt-3 mt-xxl-2 order-2 order-xxl-0'>
                          <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                            <DatePickerCustom
                              placeholder={`${t('Start Date')} - ${t('End Date')}`}
                              startDate={startDate || null}
                              endDate={endDate || null}
                              onChangePicker={handleChangePicker}
                              showOptions={[
                                'today', 'yesterday', 'two_day_ago',
                                'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                'this_week', 'last_week',
                                'this_month', 'last_month',
                              ]}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-3 order-3 order-xxl-0'>
                          <LabelWrapper label={t('Minister Code')} isShow={!!ministerCodeSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Minister Code')}...`}
                              value={ministerCodeSearch}
                              onChange={(e) => setMinisterCodeSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        {/* <Col sm={6} md={6} lg={3} xl={3} xxl={2} className='mt-3 mt-xxl-3 order-4 order-xxl-0'>
                          <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Keyword')}...`}
                              value={keywordSearch}
                              onChange={(e) => setKeywordSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col> */}
                        <Col sm={12} md={12} lg={6} xl={9} xxl={7} className='mt-3 mt-xxl-3 order-4 order-xxl-0'>
                          <LabelWrapper label={t('Article Title')} isShow={!!titleSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Article Title')}...`}
                              value={titleSearch}
                              onChange={(e) => setTitleSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={12} md={12} lg={6} xl={3} xxl={3} className="order-5 order-xxl-0 hstack gap-1 justify-content-center justify-content-sm-end justify-content-lg-end justify-content-xl-end justify-content-lg-end mt-3 mt-xxl-3">
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary me-2 me-lg-2"
                              onClick={searchData}
                              disabled={isListNewsLoading}
                            >
                              <i className="ri-search-line align-bottom me-1"></i>{" "}
                              {t('Button Search')}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary fs-14"
                              onClick={resetData}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                              {t('Button Reset')}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </NestingFilter>
                  </div>

                  <CardBody className="pt-0 px-0">

                    <div className="mx-3 my-4 mt-3">
                      <TableContainer
                        className="custom-header-css"
                        divClass="table-responsive table-card "
                        tableClass="align-middle sticky-table-ai-news"
                        theadClass="table-light"
                        columns={columns}
                        data={listNews?.list?.length ? listNews?.list : []}
                        customPageSize={query.limit}
                        customPageIndex={query.page - 1}
                        totalRecords={listNews?.total}
                        customPageCount={Math.ceil(Number(listNews?.total) / Number(query?.limit || 300))}
                        handleChangePage={handleChangePage}
                        manualSorting={true}
                        sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                        handleChangeSorting={handleChangeSorting}
                        isLoading={isListNewsLoading}
                        isShowPagination={true}
                        isShowLoadingBottom={false}
                        isScrollToTop={true}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )}</Row>
        </Container>
        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />
        <Modal
          isOpen={!!newsDetail}
          centered={true}
          size="xl"
          className={`border-header-footer modal-fullscreen`}
          scrollable={false}
          toggle={onCloseClick}
          keyboard={true}
          innerRef={modalRef}
        >
          <ModalHeader toggle={onCloseClick}>
            <div className="d-flex flex-column flex-sm-row gap-0 gap-sm-2 fs-18 fs-md-20">
              <div className="flex-grow-1">
                {t('Logo Based News')}: <span style={{ backgroundColor: '#ffff00' }}>{newsDetail?.keyword || ''}</span> {!!newsDetail?.keyword_sub && <> - <span style={{ backgroundColor: '#a8d2fb' }}>{newsDetail?.keyword_sub || ''}</span></>}
                <ButtonLanguage currentLang={currentLang} handleChangeLang={handleChangeLang} />
                <span className={`mx-2 rounded-pill badge bg-${COLORS_STATUS_NEWS[`${newsDetail?.is_used || 0}`] || 'success'}`}>
                  {STATUS_NEWS_OPTIONS_LANG?.find((s) => String(s?.value) === String(newsDetail?.is_used))?.label || ''}
                </span>
              </div>
            </div>
          </ModalHeader>
          <ModalBody className="position-relative">
            <span className="position-absolute text-success fs-13 text-end px-2 d-none d-lg-block" style={{
              top: position?.top1,
              left: position?.left1 + 10,
              transform: `translateY(-${position?.top1 - 10}px)`,
              zIndex: 9,
              backgroundColor: 'var(--vz-secondary-bg)'
            }}>
              {t('Generated News')}
            </span>
            <span className="position-absolute text-primary fs-13 text-end px-2 d-none d-lg-block" style={{
              top: position?.top2,
              left: position?.left2 + 10,
              transform: `translateY(-${position?.top2 - 10}px)`,
              zIndex: 9,
              backgroundColor: 'var(--vz-secondary-bg)'
            }}>
              {typeShowInfoRight === 'SOURCE' ? t('Source News') : t('Google Image')}
            </span>
            <div className="h-100-pc w-100 overflow-x-hidden">
              <Row className="w-100-pc px-0 h-100-pc">
                <Col lg={8} className="h-100-pc mt-2 mt-md-0">
                  <span className="position-absolute text-success fs-13 text-end px-2 d-block d-lg-none" style={{
                    top: 0,
                    left: 5,
                    transform: `translateY(-${10}px)`,
                    zIndex: 9,
                    backgroundColor: 'var(--vz-secondary-bg)'
                  }}>
                    {t('Generated News')}
                  </span>
                  <div ref={modalBodyInnerRef} className="inner-modal-body color-scrollbar-os position-relative p-0 editor-border-radius-0" style={{ border: '1.5px dashed var(--vz-success)' }}>
                    <BoxGeneratedNews ref={refContentNews} newsDetail={newsDetail} imageInsert={imageInsert} isHighlightDate={true} isEdit={true} />
                  </div>
                </Col>
                <Col lg={4} className="h-100-pc ms-0 ms-lg-0 pe-3 me-lg-0 mt-4  mt-md-0" >
                  <span className="position-absolute text-primary fs-13 text-end px-2 d-block d-lg-none" style={{
                    top: 0,
                    left: 5,
                    transform: `translateY(-${10}px)`,
                    zIndex: 9,
                    backgroundColor: 'var(--vz-secondary-bg)'
                  }}>
                    {typeShowInfoRight === 'SOURCE' ? t('Source News') : t('Google Image')}
                  </span>
                  {typeShowInfoRight === 'IMAGE' ? <Row className={`h-100-pc align-content-between position-relative gap-3 gap-lg-0 `}>
                    <div className={`box-source-image overflow-y-hidden overflow-x-hidden px-0 `}>
                      <BoxImageSearch keyword={newsDetail?.keyword || ''} ref={modalBodyInnerRef} news_id={newsDetail?.id} categories={imageCategories} onSetImageInsert={onSetImageInsert} resetCursorToStart={resetCursorToStart} />
                    </div>
                  </Row> :
                    <div className={`row h-100-pc align-content-between gap-3 gap-lg-0}`} ref={refRight}>
                      {((newsDetail ? [newsDetail] : []) as any)?.map((item: any, index: any) => {
                        if (!modalSourceInnerRefs.current[index]) {
                          modalSourceInnerRefs.current[index] = React.createRef<HTMLDivElement>().current;
                        }
                        return (
                          <div ref={(el) => (modalSourceInnerRefs.current[index] = el)} key={index} className={`color-scrollbar-os position-relative box-source-news chill-1 px-0`}>
                            <BoxSourceNews item={item} index={index} session={newsDetail?.section} keyword={newsDetail?.keyword} keyword_sub={newsDetail?.keyword_sub} />
                          </div>
                        )
                      })}
                    </div>
                  }
                </Col>
              </Row>
            </div>
          </ModalBody>
          <ModalFooter className="position-relative footer-button-new" lang={i18n?.language || 'en'}>
            <BoxFooterNews
              newsDetail={newsDetail}
              isListNewsLoading={isListNewsLoading}
              type_page_no_param={query?.type_page_no_param}
              currentLang={currentLang}
              isSaving={isSaving}
              isShowSave={true}
              publishNewsType={PUBLISH_NEWS_TYPE.AI_NEWS}
              handlePreviousNews={handlePreviousNews}
              handleNextNews={handleNextNews}
              handleDownloaded={handleDownloaded}
              handlePublished={handlePublished}
              handleUnPublished={handleUnPublished}
              onCloseClick={onCloseClick}
              onSaveClick={onSaveClick}
              onShowInfoRightClick={onShowInfoRightClick}
              typeShowInfoRight={typeShowInfoRight}
              partners={partners}
            />
          </ModalFooter>
        </Modal>


        <ModalConfigGenerate
          isOpen={isOpenModalConfigPrompt}
          onClose={() => setIsOpenModalConfigPrompt((_prev: any) => false)}
        />

        <ModalConfirm
          header={t('Button Delete News')}
          isOpen={isOpenConfirm}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionDelete}
        />
      </div >
    </React.Fragment >
  );
};

export default LogoBasedNewsList;